/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ZerogValidatorListRequest = {
    sortField?: ZerogValidatorListRequest.sortField;
    sortDirection?: ZerogValidatorListRequest.sortDirection;
    term?: string;
    status?: ZerogValidatorListRequest.status;
};

export namespace ZerogValidatorListRequest {

    export enum sortField {
        COMMISSION = 'COMMISSION',
        DELEGATION_AMOUNT = 'DELEGATION_AMOUNT',
        DELEGATOR = 'DELEGATOR',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }

    export enum status {
        ACTIVE = 'ACTIVE',
        INACTIVE = 'INACTIVE',
    }


}

